import { call, put } from "redux-saga/effects";
import { Mixpanel } from "../../../services/Mixpanel";
import { setCookie } from "../../../utils/cookies";

// API
import { loginWithGoogle } from "../../../api";

// Actions
import { authActions } from "../../../actions/auth";

export function* googleSignIn({ payload: { user, oAuthToken, location, history } }) {
  yield put(authActions.startLoading());

  try {
    const credentials = { 
      token: user.accessToken,      // Firebase user token
      access_token: oAuthToken,       // Google OAuth token
      location: location
    };
    
    const { response, error } = yield call(loginWithGoogle, credentials);

    yield put(authActions.finishLoading());

    if (response) {
      yield put(authActions.loginSuccess(response));

      // Store user token & info in localStorage
      yield call([localStorage, "setItem"], "access_token", response.profile.token);
      yield call(setCookie, "access_token", response.profile.token, 30);
      yield call([localStorage, "setItem"], "user_info", JSON.stringify(response));
      yield call(setCookie, "user_info", encodeURIComponent(JSON.stringify(response)), 30);

      if (response.is_new_user) {
        // Set user creation date for new users with user-specific key
        const now = new Date().toISOString();
        const timestamp = Math.floor(Date.now() / 1000); // Unix timestamp in seconds
        const userSpecificCreationKey = `user_creation_date_${response.uid}`;
        const userSpecificTimestampKey = `user_creation_timestamp_${response.uid}`;
        const userSpecificReminderKey = `profile_reminder_shown_${response.uid}`;
        
        // Set creation date and initialize reminder shown to false
        yield call([localStorage, "setItem"], userSpecificCreationKey, now);
        yield call([localStorage, "setItem"], userSpecificTimestampKey, timestamp.toString());
        yield call([localStorage, "setItem"], userSpecificReminderKey, "false");
      }

      // Handle redirect
      const lastUrl = localStorage.getItem("lastUrl");
      
      if (lastUrl) {
        yield call([history, "push"], lastUrl);
        yield call([localStorage, "removeItem"], "lastUrl");
      } else {
        if (response.business_role) {
          yield call([history, "push"], `/${response.slug}/profile/artefacts`);
        } else {
          yield call([history, "push"], `/${response.slug}/profile`);
        }
      }

      // Mixpanel tracking
      Mixpanel.identify(response.profile.email);
      Mixpanel.track('Log In');
      Mixpanel.people.set({
        $name: response.profile.first_name,
        $email: response.profile.email,
      });
    } else if (error) {
      yield put(authActions.loginFailed(error));
    }
  } catch (error) {
    console.error("Login error:", error);
    yield put(authActions.loginFailed(error));
  }
}